import React from 'react';
import PrivacyPolicy from '../PricvacyPolicy';
import { Link } from 'react-router-dom';

const KomunityPrivacyPolicy = () => {
  const appSpecificContent = {
    en: {
      developer: "Developer: 물가의새",
      title: "Komunity Privacy Policy",
      lastUpdated: "Last Updated: April 2, 2025",
      collectInfo: "1. Information We Collect",
      collectDescription:
        "Komunity collects the following information to enhance your community experience:",
      collectList: [
        "User profile information (username, profile picture, bio)",
        "Community posts, comments, and interactions",
        "Content preferences and interests",
        "Communication with other users"
      ],
      usagePurpose: "2. Purpose of Information Use",
      usageDescription: "We use your information to:",
      usageList: [
        "Create and maintain your community profile",
        "Connect you with relevant communities and content",
        "Improve community features and moderation",
        "Personalize your experience based on interests"
      ],
      dataSharing: "3. Data Sharing & Third-Party Disclosure",
      sharingDescription:
        "Public posts and profile information are visible to other Komunity users. We do not sell personal data to advertisers, though anonymized usage data may be used for improving community recommendations.",
      dataStorage: "4. Data Retention & Deletion",
      storageDescription:
        "Your community data remains active until you choose to delete specific content or your entire account. Deleted content may persist in backups for up to 30 days.",
      contact: "5. Contact",
      contactDescription: "For privacy inquiries related to Komunity, please contact komunity1011@gmail.com",
      changeLang: "Change to Korean",
      childPolicyButton: "Child Safety Policy",
    },
    ko: {
      developer: "개발자: 물가의새",
      title: "코뮤니티 개인정보처리방침",
      lastUpdated: "최종 업데이트 날짜: 2025년 4월 2일",
      collectInfo: "1. 수집하는 정보",
      collectDescription:
        "코뮤니티는 커뮤니티 경험을 향상시키기 위해 다음 정보를 수집합니다:",
      collectList: [
        "사용자 프로필 정보(사용자 이름, 프로필 사진, 자기소개)",
        "커뮤니티 게시물, 댓글 및 상호작용",
        "콘텐츠 선호도 및 관심사",
        "다른 사용자와의 통신"
      ],
      usagePurpose: "2. 정보 이용 목적",
      usageDescription: "수집된 정보는 다음과 같이 활용됩니다:",
      usageList: [
        "커뮤니티 프로필 생성 및 유지",
        "관련 커뮤니티 및 콘텐츠 연결",
        "커뮤니티 기능 및 모더레이션 개선",
        "관심사에 기반한 경험 개인화"
      ],
      dataSharing: "3. 정보 공유 및 제3자 제공",
      sharingDescription:
        "공개 게시물 및 프로필 정보는 다른 코뮤니티 사용자에게 표시됩니다. 개인 데이터를 광고주에게 판매하지 않지만, 익명화된 사용 데이터는 커뮤니티 추천 개선에 활용될 수 있습니다.",
      dataStorage: "4. 데이터 보관 및 삭제",
      storageDescription:
        "귀하의 커뮤니티 데이터는 특정 콘텐츠 또는 전체 계정을 삭제하기로 선택할 때까지 활성 상태로 유지됩니다. 삭제된 콘텐츠는 백업에 최대 30일까지 남아있을 수 있습니다.",
      contact: "5. 연락처",
      contactDescription: "코뮤니티 관련 개인정보 문의는 komunity1011@gmail.com으로 연락주세요.",
      changeLang: "영어로 변경",
      childPolicyButton: "아동 보호 정책",
    },
  };

  // Custom render function to add the child policy button
  const renderCustomHeader = (language, setLanguage, content) => (
    <div style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
      <button
        onClick={() => setLanguage(language === "en" ? "ko" : "en")}
        style={{
          padding: "8px 12px",
          backgroundColor: "#4527A0",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        {content[language].changeLang}
      </button>

      <Link to="/csae-policy">
        <button style={{
          padding: "8px 12px",
          backgroundColor: "#9C27B0",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}>
          {content[language].childPolicyButton}
        </button>
      </Link>
    </div>
  );

  return <PrivacyPolicy
    customContent={appSpecificContent}
    renderCustomHeader={renderCustomHeader}
  />;
};

export default KomunityPrivacyPolicy;